import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { QualityControlSubWorkOrder } from '../../../../common/quality-control/model/sub-work-order-qc.ts';
import { SchedulerStageItemService } from '../../../../views/scheduler-stage/services/item.service';
import {
  SchedulerStageRegisterProgressComponent,
  SchedulerStageRegisterProgressTypes,
} from '../../../../views/scheduler-stage/dialog/finish-stage/finish-stage.component';

@Injectable()
export class HosesQCRejectedItemService extends SchedulerStageItemService {
  override registerProgress(
    item: QualityControlSubWorkOrder
  ): Observable<QualityControlSubWorkOrder> {
    if (!item) {
      return;
    }
    return this.registerProgressDialog(item).pipe(
      switchMap((res) => {
        return this.registerProgressReport(item, res, true);
      })
    );
  }

  protected registerProgressDialog(
    itemSelected: QualityControlSubWorkOrder
  ): Observable<SchedulerStageRegisterProgressTypes['return']> {
    return this.dialog
      .open(SchedulerStageRegisterProgressComponent, {
        data: {
          maxQuantity: itemSelected.quantity,
          title: itemSelected.title,
          department: this.departmentService.NAME,
        },
        minWidth: '50%',
      })
      .afterClosed()
      .pipe(filter((data) => !!data));
  }

  protected registerProgressReport(
    itemSelected: QualityControlSubWorkOrder,
    res: SchedulerStageRegisterProgressTypes['return'],
    toQc?: boolean
  ): Observable<QualityControlSubWorkOrder> {
    return this.apiStageRouter.finishSubWorkOrderStage({
      itemId: itemSelected.workOrderId,
      stageId: itemSelected.stageId,
      quantity: res.quantity,
      scrapReasons: res.scrapReasons,
      shiftId: res.shiftId,
      toValidation: !toQc,
      nextStage: toQc ? 'Quality Control' : undefined,
    });
  }
}